import React from "react"
import { Grid, useTheme, Box } from "@material-ui/core"

import ServiceItem from "./service-item"

const ServiceList = () => {
  const theme = useTheme()

  return (
    <Box maxWidth="700px" margin="0 auto">
      <Grid container spacing={6} justify="center">
        {theme.data.pages.index.serviceList.map(
          ({ imgName, alt, title, description }) => {
            return (
              <Grid item key={title} md={4}>
                <ServiceItem
                  imgName={imgName}
                  alt={alt}
                  title={title}
                  description={description}
                />
              </Grid>
            )
          }
        )}
      </Grid>
    </Box>
  )
}

export default ServiceList
